'use client'

import React, { useContext, useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons";

import { AuthContext } from "@/context/authContext";
import customAlert from "@/util/customAlert";
import default_image from "@/public/icon/default_user.svg";
import EditView from "./edit";

import ComentWrite from "./coment_write";
import CommentList from "./coment";

import { editPageTypes } from "@/type/edit";
import api from "@/util/api";
import { CommentListType } from "@/type/list";
import ParsedHtmlContent from "../etc/renderContent"
import { usePathname, useRouter } from "next/navigation";
import { useTranslations } from "next-intl";
import LocaleFormat from "../etc/localeFormat";

/**
  
  // 기본
<BoardDetailV2 selectContent={selectContent}
                setSelectContent={setSelectContent}
                post="/api/community/"
                fetchData={() => {}}
                writeAuth={false}
                editAuth={false} />


  // 본문 커스텀
<BoardDetailV2 selectContent={selectContent}
                setSelectContent={setSelectContent}
                fetchData={fetchData}
                post="/api/community/"
                renderBody={(c) => (
                    <div>
                        내용내용
                    </div>
                )} />


  // 푸터 커스텀
<BoardDetailV2 selectContent={selectContent}
                setSelectContent={setSelectContent}
                fetchData={fetchData}
                post="/api/community/"
                renderFooter={(c) => (
                    <div>
                    조회수: {c.view_count}
                    </div>
                )} />

  // 댓글영역 커스텀
<BoardDetailV2 selectContent={selectContent}
                setSelectContent={setSelectContent}
                fetchData={fetchData}
                post="/api/community/">
                <div>
                    <h4>내용내용</h4>
                    <div>내용내용</div>
                </div>
                </BoardDetailV2>

 */

interface ViewProps extends React.HTMLAttributes<HTMLDivElement> {
    selectContent: any;
    setSelectContent: Function;
    fetchData?: () => void;
    post?: string;

    writeAuth?: boolean;
    editAuth?: boolean;
    editPage?: editPageTypes;
    editCategory?: number;

    isComment?:boolean
    isrecommend?:boolean

    // 커스텀 포인트
    renderHeader?: (content: any) => React.ReactNode;
    renderBody?: (content: any) => React.ReactNode;
    renderFooter?: (content: any) => React.ReactNode;
    children?: React.ReactNode;
    className?:string;

    isFirstRender?:boolean;
    setIsFirstRender?:Function;
}

const BoardDetailV2 = React.forwardRef<HTMLDivElement, ViewProps>(
    (
        {
            selectContent,
            setSelectContent,
            fetchData ,
            post = "",
            writeAuth = false,
            editAuth = false,
            editPage = "defualt",
            editCategory = 2,

            isComment=true,
            isrecommend=true,

            renderHeader,
            renderBody,
            renderFooter,
            children,
            className = "",

            isFirstRender,
            setIsFirstRender,
            ...rest
        },
        ref
    ) => {
        const { user } = useContext(AuthContext);
        const [editView, setEditView] = useState<boolean>(false);
        const [editContent, setEditContent] = useState<any>();
        const recomRef = useRef<HTMLButtonElement>(null);
        const [likeCount, setLikeCount] = useState<number>(0);
        const [scrollHold, setScrollHold] = useState<boolean>(false);

        
        const router = useRouter();
        const pathname = usePathname();

        const a = useTranslations('Sentence')
        const t = useTranslations('Text')


        function clickLike(id: number) {
            if (!user?.is_authenticated) {
                customAlert(a("NeedLogin"), "warning");
                return;
            }
            if(!post || post == ""){
                customAlert(a("WrongContents"), "warning");
                return;
            }
            api(`${post}like/${id}/`, { method: "POST" })
                .then((res) => res.json())
                .then(({ data }) => {
                    if (!recomRef.current) return;
                    const span = recomRef.current.querySelector("span");
                    if (span) span.textContent = String(data.liked_count);
                    recomRef.current.classList.toggle("active", !!data.is_liked);           
                    if (typeof fetchData === "function"){ 
                        setScrollHold(true);
                        fetchData();
                    }

                })
                .catch((err) => console.error("like error", err));
        }

        function setfetchData() {
            const cleanUrl = window.location.origin + window.location.pathname;
            window.history.replaceState({}, "", cleanUrl);
            setEditView(false);
            fetchData?.()
            // if (typeof fetchData === 'function') fetchData();
        }

        async function deleteContent() {
            if (!selectContent?.id) {
                customAlert(a("WrongContents"), "warning");
                return;
            }

            await customAlert(a("ConfirmBoardDelete"), "question", () => {
                const formData = new FormData();
                formData.set("id", selectContent.id);
                formData.set("cate", String(editCategory));

                api(post + "delete/", { method: "POST", body: formData })
                    .then((res) => res.json())
                    .then(({ status, message }) => {
                        customAlert(message, status);
                        setfetchData();
                    })
                    .catch(() => customAlert(a("ErrorRequest"), "error"));
                    
            }, {
                confirmMode: true,
                onCancel: () => {return false},
            });
           
        }

        useEffect(() => {
            if (!scrollHold && isFirstRender) {
                requestAnimationFrame(() => {
                    setTimeout(() => {
                        window.scrollTo({ top: 0, behavior: "instant" });
                        if (setIsFirstRender) setIsFirstRender(false);
                    }, 60);
                });
            }
            setScrollHold(false);
        }, [selectContent]);



        
        useEffect(() => {
            if(selectContent) setLikeCount(selectContent.like_count ?? selectContent.likes ?? 0);
            setEditView(false);
        }, [selectContent]);

        if (!selectContent) return null;

        return (
            <div className={` ${className ? className : "board-view"}`} ref={ref} {...rest}>
                {editView ? (
                    <EditView post={post}
                              editContent={editContent}
                              setSelectContent={setSelectContent}
                              setEditView={setEditView}
                              fetchData={fetchData}
                              editPage={editPage as editPageTypes} />
                ) : (
                    <>

                            {renderBody ? (
                                renderBody(selectContent)
                            ) : (
                                <>
                                        <div className="view-title">
                                            <header>
                                                <div className="title">
                                                    <div dangerouslySetInnerHTML={{__html: selectContent.title}}></div>
                                                    {/* {selectContent.title} */}
                                                </div>
                                                <div className="author">
                                                    <div className="profile-image">
                                                        <img src={default_image.src} alt="" />
                                                    </div>
                                                    <div className="info">
                                                        <div className="nickname">
                                                            {selectContent.author_name || selectContent.author_username}
                                                        </div>
                                                        <span>
                                                            {<LocaleFormat date={selectContent.create_dt} format="MM-DD HH:mm" />}
                                                        </span>
                                                    </div>
                                                </div>
                                            </header>
                                        </div>
                                        <main style={{ overflowWrap: "break-word" }}>
                                            <ParsedHtmlContent html={selectContent.content} />
                                            {/* <div dangerouslySetInnerHTML={{ __html: selectContent?.content ?? "", }} /> */}
                                        </main>
                                </>
                            )}

                        <div className="btns">
                            {selectContent.is_author && user?.is_authenticated && (
                                <>
                                <div className="w-100-per flex center m-b-10">
                                    <button className="editBtn"
                                            onClick={() => {
                                                setEditContent(selectContent);
                                                setEditView(true);
                                            }}>{t('수정')}</button>
                                    <button className="deleteBtn"
                                            onClick={deleteContent}>{t('삭제')}</button>
                                </div>
                                </>
                            )}

                        <div>
                            {isrecommend && 
                                <button className={`recomBtn ${ selectContent.is_liked ? "active" : "" }`}
                                        onClick={() => clickLike(selectContent.id)}
                                        ref={recomRef}>
                                    <FontAwesomeIcon icon={faThumbsUp} />
                                    <span>
                                        {likeCount || 0}
                                    </span>
                                </button>
                            }
                            <button className="listBtn"
                                    onClick={() => {
                                        setSelectContent(undefined);
                                        window.scrollTo({ top: 0, behavior: "smooth" });
                                        
                                        router.replace(pathname);
                                    }}>{t('목록')}</button>
                            </div>
                        </div>

                        {renderFooter && renderFooter(selectContent)}

                        {children ?? (
                            isComment &&
                            <>
                                <ComentWrite board_id={selectContent.id} 
                                            fetchData={fetchData} 
                                            post={post}
                                            setSelectContent={setSelectContent}
                                            selectContent={selectContent} />

                                <CommentList comments={selectContent.comments} 
                                              post={post}
                                              setSelectContent={setSelectContent} />
                            </>
                        )}
                    </>
                )}
            </div>
        );
    }
);

BoardDetailV2.displayName = "BoardDetailV2";
export default BoardDetailV2;
